import { Route, Routes } from "react-router-dom";
import { OSCI0205001Q } from "@/tz/go/egaz/osci/lpco/fee/OSCI0205001Q";
import { OSCI0205002S } from "@/tz/go/egaz/osci/lpco/fee/OSCI0205002S";
import { OSCI0205003Q } from "@/tz/go/egaz/osci/lpco/fee/OSCI0205003Q";
import { OSCI0205004S } from "@/tz/go/egaz/osci/lpco/fee/OSCI0205004S";
import { OSCI0205005Q } from "@/tz/go/egaz/osci/lpco/fee/OSCI0205005Q";
import { OSCI0205006S } from "@/tz/go/egaz/osci/lpco/fee/OSCI0205006S";
import { OSCI0205007Q } from "@/tz/go/egaz/osci/lpco/fee/OSCI0205007Q";
import { OSCI0205008S } from "@/tz/go/egaz/osci/lpco/fee/OSCI0205008S";
import { OSCI0205009Q } from "@/tz/go/egaz/osci/lpco/fee/OSCI0205009Q";
import { OSCI0205010Q } from "../fee/OSCI0205010Q";
import { OSCI0205011S } from "../fee/OSCI0205011S";

/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 * TODO URL의 'key' 를 실제 ID로 변경 하세요.
 * TODO 위의 한글 주석은 마지막에 전부 삭제하세요.
 */

export const OsciLpcoFeeRouter = () => {
    return (
        <Routes>
            {/*  !== 고지 미납 납부 결과 ==! */}
            <Route path="osci0205001q" element={<OSCI0205001Q />} />
            <Route path="osci0205002s/:uuid" element={<OSCI0205002S />} />
            <Route path="osci0205003q" element={<OSCI0205003Q />} />
            <Route path="osci0205004s/:uuid" element={<OSCI0205004S />} />
            <Route path="osci0205005q" element={<OSCI0205005Q />} />
            <Route path="osci0205006s/:uuid" element={<OSCI0205006S />} />
            <Route path="osci0205007q" element={<OSCI0205007Q />} />
            <Route path="osci0205008s/:uuid" element={<OSCI0205008S />} />
            <Route path="osci0205008s/:appNo/:appDgr" element={<OSCI0205008S />} />
            <Route path="osci0205009q" element={<OSCI0205009Q />} />
            <Route path="osci0205010q/:bllMgmtId" element={<OSCI0205010Q />} />
            <Route path="osci0205011s/:mode" element={<OSCI0205011S />} />
            <Route path="osci0205011s/:mode/:bllMgmtId" element={<OSCI0205011S />} />
        </Routes>
    );
};
